module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.name),
      expression: "agency.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('name'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.agency.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nationality")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.national),
      expression: "agency.national"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "national",
      "id": "national"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.agency, "national", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.nationality]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Nacional")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Internacional")])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.email),
      expression: "agency.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('email'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.agency.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), (_vm.agency_id === null) ? _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.password),
      expression: "agency.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('password'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.agency.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Social Reason")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.social_reason),
      expression: "agency.social_reason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('social_reason'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "social_reason",
      "id": "social_reason",
      "placeholder": "Social Reason"
    },
    domProps: {
      "value": (_vm.agency.social_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "social_reason", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('social_reason')),
      expression: "errors.has('social_reason')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('social_reason')))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCep),
      expression: "showCep"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.cnpj),
      expression: "agency.cnpj"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: parseInt(_vm.agency.national) == !0,
        numeric: true
      }),
      expression: "{ required: parseInt(agency.national) ==! 0, numeric: true }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('cnpj'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "cnpj",
      "id": "cnpj",
      "placeholder": "CNPJ"
    },
    domProps: {
      "value": (_vm.agency.cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "cnpj", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cnpj')),
      expression: "errors.has('cnpj')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cnpj')))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCep),
      expression: "showCep"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Municipal Inscription")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.municipal_inscription),
      expression: "agency.municipal_inscription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('municipal_inscription'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "municipal_inscription",
      "id": "municipal_inscription",
      "placeholder": "Municipal Inscription"
    },
    domProps: {
      "value": (_vm.agency.municipal_inscription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "municipal_inscription", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('municipal_inscription')),
      expression: "errors.has('municipal_inscription')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('municipal_inscription')))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 4 && parseInt(_vm.agency.national) === 1),
      expression: "parseInt(context.$store.state.config.user.level) < 4 && parseInt(agency.national) === 1"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.nf),
      expression: "agency.nf"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agency.nf) ? _vm._i(_vm.agency.nf, null) > -1 : (_vm.agency.nf)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agency.nf,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.agency, "nf", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.agency, "nf", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.agency, "nf", $$c)
        }
      }
    }
  }), _vm._v("\n          NFS-e\n        ")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 4),
      expression: "parseInt(context.$store.state.config.user.level) < 4"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.commission),
      expression: "agency.commission"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agency.commission) ? _vm._i(_vm.agency.commission, null) > -1 : (_vm.agency.commission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agency.commission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.agency, "commission", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.agency, "commission", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.agency, "commission", $$c)
        }
      }
    }
  }), _vm._v("\n          Commission "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.commission_value),
      expression: "agency.commission_value"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('commission'),
      'is-disabled': _vm.agency.commission ? false : true
    },
    staticStyle: {
      "width": "4rem",
      "vertical-align": "middle"
    },
    attrs: {
      "type": "text",
      "name": "commission_value",
      "id": "commission_value"
    },
    domProps: {
      "value": (_vm.agency.commission_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "commission_value", $event.target.value)
      }
    }
  }), _vm._v(" %\n        ")])]), _vm._v(" "), ((parseInt(_vm.context.$store.state.config.user.level) < 4) && parseInt(_vm.agency.national) === 1) ? _c('div', {
    staticStyle: {
      "margin-bottom": "0.5rem"
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.boleto),
      expression: "agency.boleto"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agency.boleto) ? _vm._i(_vm.agency.boleto, null) > -1 : (_vm.agency.boleto)
    },
    on: {
      "click": _vm.setBoleto,
      "change": function($event) {
        var $$a = _vm.agency.boleto,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.agency, "boleto", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.agency, "boleto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.agency, "boleto", $$c)
        }
      }
    }
  }), _vm._v("\n          Boleto\n          "), ((_vm.agency.boleto === 1 || _vm.agency.boleto === true)) ? _c('span', {
    staticStyle: {
      "margin-left": "3rem"
    }
  }, [_vm._v("\n            Negativação (1~30) "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.negativacao),
      expression: "agency.negativacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|max_value:30'),
      expression: "'required|numeric|max_value:30'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('negativacao'),
      'is-disabled': _vm.inProgress
    },
    staticStyle: {
      "width": "2.5rem",
      "vertical-align": "middle"
    },
    attrs: {
      "type": "",
      "name": "negativacao",
      "id": "negativacao"
    },
    domProps: {
      "value": (_vm.agency.negativacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "negativacao", $event.target.value)
      }
    }
  }), _vm._v(" days\n          ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('negativacao')),
      expression: "errors.has('negativacao')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('negativacao')))]), _vm._v(" "), ((_vm.agency.boleto === 1 || _vm.agency.boleto === true)) ? _c('span', {
    staticStyle: {
      "margin-left": "3rem"
    }
  }, [_vm._v("\n            Protesto (2~30) "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.protesto),
      expression: "agency.protesto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|max_value:30'),
      expression: "'required|numeric|max_value:30'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('protesto'),
      'is-disabled': _vm.inProgress
    },
    staticStyle: {
      "width": "2.5rem",
      "vertical-align": "middle"
    },
    attrs: {
      "type": "",
      "name": "protesto",
      "id": "protesto"
    },
    domProps: {
      "value": (_vm.agency.protesto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "protesto", $event.target.value)
      }
    }
  }), _vm._v(" days\n          ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('protesto')),
      expression: "errors.has('protesto')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('protesto')))])]), _vm._v(" "), ((_vm.agency.boleto === 1 || _vm.agency.boleto === true)) ? _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Banco")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.banco),
      expression: "agency.banco"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1'),
      expression: "'required|min_value:1'"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "banco",
      "id": "banco"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.agency, "banco", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Escolha um banco para emissão do boleto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bradesco")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Santander")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Itau")])])]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('banco')),
      expression: "errors.has('banco')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Necessário escolher um banco para emissão do boleto")])]) : _vm._e(), _vm._v(" "), ((parseInt(_vm.context.$store.state.config.user.level) < 4)) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.card),
      expression: "agency.card"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agency.card) ? _vm._i(_vm.agency.card, null) > -1 : (_vm.agency.card)
    },
    on: {
      "click": _vm.setCard,
      "change": function($event) {
        var $$a = _vm.agency.card,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.agency, "card", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.agency, "card", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.agency, "card", $$c)
        }
      }
    }
  }), _vm._v(" Cartão\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 4),
      expression: "parseInt(context.$store.state.config.user.level) < 4"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Incentive")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.incentive_type),
      expression: "agency.incentive_type"
    }],
    staticClass: "select",
    attrs: {
      "name": "incentive_type",
      "id": "incentive_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.agency, "incentive_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Percentage")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Value")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.incentive_value),
      expression: "agency.incentive_value"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('incentive_value'),
      'is-disabled': parseInt(_vm.agency.incentive_type) !== 0 ? false : true
    },
    staticStyle: {
      "width": "4rem",
      "vertical-align": "middle"
    },
    attrs: {
      "type": "text",
      "name": "incentive_value",
      "id": "incentive_value"
    },
    domProps: {
      "value": (_vm.agency.incentive_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "incentive_value", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 4),
      expression: "parseInt(context.$store.state.config.user.level) < 4"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Invoice Automatic Send")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.invoice_send),
      expression: "agency.invoice_send"
    }],
    staticClass: "select",
    attrs: {
      "name": "invoice_send",
      "id": "invoice_send"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.agency, "invoice_send", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("D+1")])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.phone),
      expression: "agency.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('phone'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "phone",
      "id": "phone",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.agency.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Emergency Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.emergency_phone),
      expression: "agency.emergency_phone"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('emergency_phone'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "emergency_phone",
      "id": "emergency_phone",
      "placeholder": "Emergency Phone"
    },
    domProps: {
      "value": (_vm.agency.emergency_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "emergency_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emergency_phone')),
      expression: "errors.has('emergency_phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emergency_phone')))])])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCep),
      expression: "showCep"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.cep),
      expression: "agency.cep"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: parseInt(_vm.agency.national) == !0,
        numeric: true
      }),
      expression: "{ required: parseInt(agency.national) ==! 0, numeric: true }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('cep'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "cep",
      "name": "cep",
      "id": "cep",
      "placeholder": "CEP"
    },
    domProps: {
      "value": (_vm.agency.cep)
    },
    on: {
      "change": _vm.cep,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "cep", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cep')),
      expression: "errors.has('cep')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cep')))])]), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.address),
      expression: "agency.address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('address'),
      'is-disabled': _vm.inProgress || (_vm.cepProgress && parseInt(_vm.agency.national) === 1)
    },
    attrs: {
      "type": "text",
      "name": "address",
      "id": "address",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.agency.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Address Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.address_number),
      expression: "agency.address_number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('address_number'),
      'is-disabled': _vm.inProgress || (_vm.cepProgress && parseInt(_vm.agency.national) === 1)
    },
    attrs: {
      "type": "text",
      "name": "address_number",
      "id": "address_number",
      "placeholder": "Address Number"
    },
    domProps: {
      "value": (_vm.agency.address_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "address_number", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address_number')),
      expression: "errors.has('address_number')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address_number')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Neighborhood")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.address_neighborhood),
      expression: "agency.address_neighborhood"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('address_neighborhood'),
      'is-disabled': _vm.inProgress || (_vm.cepProgress && parseInt(_vm.agency.national) === 1)
    },
    attrs: {
      "type": "text",
      "name": "address_neighborhood",
      "id": "address_neighborhood",
      "placeholder": "Neighborhood"
    },
    domProps: {
      "value": (_vm.agency.address_neighborhood)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "address_neighborhood", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address_neighborhood')),
      expression: "errors.has('address_neighborhood')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address_neighborhood')))])])])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Address Complement")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.address_complement),
      expression: "agency.address_complement"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('address_complement'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "address_complement",
      "id": "address_complement",
      "placeholder": "Address Complement"
    },
    domProps: {
      "value": (_vm.agency.address_complement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "address_complement", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address_complement')),
      expression: "errors.has('address_complement')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address_complement')))])]), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.city),
      expression: "agency.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('city'),
      'is-disabled': _vm.inProgress || (_vm.cepProgress && parseInt(_vm.agency.national) === 1)
    },
    attrs: {
      "type": "text",
      "name": "city",
      "id": "city",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.agency.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('city')),
      expression: "errors.has('city')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('city')))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCep),
      expression: "showCep"
    }],
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("IBGE")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.cmun),
      expression: "agency.cmun"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: parseInt(_vm.agency.national) == !0
      }),
      expression: "{ required: parseInt(agency.national) ==! 0}"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('cmun'),
      'is-disabled': _vm.inProgress || (_vm.cepProgress && parseInt(_vm.agency.national) === 1)
    },
    attrs: {
      "type": "text",
      "name": "cmun",
      "id": "cmun",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.agency.cmun)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "cmun", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cmun')),
      expression: "errors.has('cmun')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cmun')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.state),
      expression: "agency.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('state'),
      'is-disabled': _vm.inProgress || (_vm.cepProgress && parseInt(_vm.agency.national) === 1)
    },
    attrs: {
      "type": "text",
      "name": "state",
      "id": "state",
      "placeholder": "State"
    },
    domProps: {
      "value": (_vm.agency.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "state", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state')),
      expression: "errors.has('state')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.country),
      expression: "agency.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('country'),
      'is-disabled': _vm.inProgress || (_vm.cepProgress && parseInt(_vm.agency.national) === 1)
    },
    attrs: {
      "type": "text",
      "name": "country",
      "id": "country",
      "placeholder": "Country"
    },
    domProps: {
      "value": (_vm.agency.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "country", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('country')),
      expression: "errors.has('country')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('country')))])])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Site")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.website),
      expression: "agency.website"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('website'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "website",
      "id": "website",
      "placeholder": "Site"
    },
    domProps: {
      "value": (_vm.agency.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "website", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('website')),
      expression: "errors.has('website')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('website')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.payment),
      expression: "agency.payment"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "payment",
      "id": "payment"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.agency, "payment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.context.$store.state.config.agency.payment), function(payment) {
    return _c('option', {
      key: payment.id,
      domProps: {
        "value": payment.id
      }
    }, [_vm._v(_vm._s(payment.name))])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Timezone")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.timezone),
      expression: "agency.timezone"
    }],
    staticClass: "is-fullwidth",
    attrs: {
      "name": "timezone",
      "id": "timezone"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.agency, "timezone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-12:00"
    }
  }, [_vm._v("(GMT -12:00) Eniwetok, Kwajalein")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-11:00"
    }
  }, [_vm._v("(GMT -11:00) Midway Island, Samoa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-10:00"
    }
  }, [_vm._v("(GMT -10:00) Hawaii")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-09:50"
    }
  }, [_vm._v("(GMT -9:30) Taiohae")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-09:00"
    }
  }, [_vm._v("(GMT -9:00) Alaska")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-08:00"
    }
  }, [_vm._v("(GMT -8:00) Pacific Time (US & Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-07:00"
    }
  }, [_vm._v("(GMT -7:00) Mountain Time (US & Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-06:00"
    }
  }, [_vm._v("(GMT -6:00) Central Time (US & Canada), Mexico City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-05:00"
    }
  }, [_vm._v("(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-04:50"
    }
  }, [_vm._v("(GMT -4:30) Caracas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-04:00"
    }
  }, [_vm._v("(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-03:50"
    }
  }, [_vm._v("(GMT -3:30) Newfoundland")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-03:00"
    }
  }, [_vm._v("(GMT -3:00) Brazil, Buenos Aires, Georgetown")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-02:00"
    }
  }, [_vm._v("(GMT -2:00) Mid-Atlantic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-01:00"
    }
  }, [_vm._v("(GMT -1:00) Azores, Cape Verde Islands")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+00:00"
    }
  }, [_vm._v("(GMT) Western Europe Time, London, Lisbon, Casablanca")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+01:00"
    }
  }, [_vm._v("(GMT +1:00) Brussels, Copenhagen, Madrid, Paris")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+02:00"
    }
  }, [_vm._v("(GMT +2:00) Kaliningrad, South Africa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+03:00"
    }
  }, [_vm._v("(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+03:50"
    }
  }, [_vm._v("(GMT +3:30) Tehran")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+04:00"
    }
  }, [_vm._v("(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+04:50"
    }
  }, [_vm._v("(GMT +4:30) Kabul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+05:00"
    }
  }, [_vm._v("(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+05:50"
    }
  }, [_vm._v("(GMT +5:30) Bombay, Calcutta, Madras, New Delhi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+05:75"
    }
  }, [_vm._v("(GMT +5:45) Kathmandu, Pokhara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+06:00"
    }
  }, [_vm._v("(GMT +6:00) Almaty, Dhaka, Colombo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+06:50"
    }
  }, [_vm._v("(GMT +6:30) Yangon, Mandalay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+07:00"
    }
  }, [_vm._v("(GMT +7:00) Bangkok, Hanoi, Jakarta")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+08:00"
    }
  }, [_vm._v("(GMT +8:00) Beijing, Perth, Singapore, Hong Kong")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+08:75"
    }
  }, [_vm._v("(GMT +8:45) Eucla")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+09:00"
    }
  }, [_vm._v("(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+09:50"
    }
  }, [_vm._v("(GMT +9:30) Adelaide, Darwin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+10:00"
    }
  }, [_vm._v("(GMT +10:00) Eastern Australia, Guam, Vladivostok")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+10:50"
    }
  }, [_vm._v("(GMT +10:30) Lord Howe Island")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+11:00"
    }
  }, [_vm._v("(GMT +11:00) Magadan, Solomon Islands, New Caledonia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+11:50"
    }
  }, [_vm._v("(GMT +11:30) Norfolk Island")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+12:00"
    }
  }, [_vm._v("(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+12:75"
    }
  }, [_vm._v("(GMT +12:45) Chatham Islands")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+13:00"
    }
  }, [_vm._v("(GMT +13:00) Apia, Nukualofa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+14:00"
    }
  }, [_vm._v("(GMT +14:00) Line Islands, Tokelau")])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.language),
      expression: "agency.language"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "language",
      "id": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.agency, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Portugues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Espanhol")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Ingles")])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email Voucher")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.email_voucher),
      expression: "agency.email_voucher"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('email_voucher'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "email_voucher",
      "name": "email_voucher",
      "id": "email_voucher",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.agency.email_voucher)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "email_voucher", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email_voucher')),
      expression: "errors.has('email_voucher')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email_voucher')))])]), _vm._v(" "), _c('p', {
    class: {
      'control': true
    }
  }, [_vm._m(0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.emails_invoice),
      expression: "agency.emails_invoice"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('emails_invoice')
    },
    attrs: {
      "name": "emails_invoice",
      "id": "emails_invoice",
      "placeholder": "E-mails"
    },
    domProps: {
      "value": (_vm.agency.emails_invoice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "emails_invoice", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emails_invoice')),
      expression: "errors.has('emails_invoice')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emails_invoice')))])]), _vm._v(" "), _c('p', {
    class: {
      'control': true
    }
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.emails_reconfirmation),
      expression: "agency.emails_reconfirmation"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('emails_reconfirmation')
    },
    attrs: {
      "name": "emails_reconfirmation",
      "id": "emails_reconfirmation",
      "placeholder": "E-mails"
    },
    domProps: {
      "value": (_vm.agency.emails_reconfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "emails_reconfirmation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emails_reconfirmation')),
      expression: "errors.has('emails_reconfirmation')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emails_reconfirmation')))])]), _vm._v(" "), _c('p', {
    class: {
      'control': true
    }
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.emails_notification),
      expression: "agency.emails_notification"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('emails_notification')
    },
    attrs: {
      "name": "emails_notification",
      "id": "emails_notification",
      "placeholder": "E-mails"
    },
    domProps: {
      "value": (_vm.agency.emails_notification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "emails_notification", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emails_notification')),
      expression: "errors.has('emails_notification')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emails_notification')))])]), _vm._v(" "), _c('p', {
    class: {
      'control': true
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Annotations\n        ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.annotations),
      expression: "agency.annotations"
    }],
    class: {
      'textarea': true
    },
    attrs: {
      "name": "annotations",
      "id": "annotations",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.agency.annotations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agency, "annotations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 4),
      expression: "parseInt(context.$store.state.config.user.level) < 4"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.cancel_multiple),
      expression: "agency.cancel_multiple"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agency.cancel_multiple) ? _vm._i(_vm.agency.cancel_multiple, null) > -1 : (_vm.agency.cancel_multiple)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agency.cancel_multiple,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.agency, "cancel_multiple", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.agency, "cancel_multiple", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.agency, "cancel_multiple", $$c)
        }
      }
    }
  }), _vm._v("\n          Cancel Bookings Not Equal to Confirmed\n        ")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 4),
      expression: "parseInt(context.$store.state.config.user.level) < 4"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.occurrence_email),
      expression: "agency.occurrence_email"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agency.occurrence_email) ? _vm._i(_vm.agency.occurrence_email, null) > -1 : (_vm.agency.occurrence_email)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agency.occurrence_email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.agency, "occurrence_email", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.agency, "occurrence_email", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.agency, "occurrence_email", $$c)
        }
      }
    }
  }), _vm._v("\n          Ticket by e-mail\n        ")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 4),
      expression: "parseInt(context.$store.state.config.user.level) < 4"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.cangooroo),
      expression: "agency.cangooroo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agency.cangooroo) ? _vm._i(_vm.agency.cangooroo, null) > -1 : (_vm.agency.cangooroo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agency.cangooroo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.agency, "cangooroo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.agency, "cangooroo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.agency, "cangooroo", $$c)
        }
      }
    }
  }), _vm._v("\n          Cangooroo\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Ezlink's Financial Department (Responsible for Billing)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agency.ez_financial_email),
      expression: "agency.ez_financial_email"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "ez_financial_email",
      "id": "ez_financial_email",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.agency, "ez_financial_email", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "financeiro3@ezlink.net.br"
    }
  }, [_vm._v("financeiro3@ezlink.net.br")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "financeiro6@ezlink.net.br"
    }
  }, [_vm._v("financeiro6@ezlink.net.br")])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.errors.any() || _vm.cepLoading,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_vm._v("E-mails Invoice\n          "), _c('small', [_vm._v("Ex: separate like (support@agency.com; contact@agency.com)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_vm._v("E-mails Reconfirmation\n          "), _c('small', [_vm._v("Ex: separate like (support@agency.com; contact@agency.com)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_vm._v("E-mails Notification\n          "), _c('small', [_vm._v("Ex: separate like (support@agency.com; contact@agency.com)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-311fd11d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/agencies/Agency.vue
// module id = 1101
// module chunks = 39